import { render, staticRenderFns } from "./MultiselectIcon.vue?vue&type=template&id=446d7b52"
import script from "./MultiselectIcon.vue?vue&type=script&lang=js"
export * from "./MultiselectIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports